import {createMuiTheme, makeStyles, MuiThemeProvider} from "@material-ui/core";

import About from "./components/About";
import Contact from "./components/Contact";
import MyWork from "./components/MyWork";
import NavBar from "./components/NavBar";
import Skills from "./components/Skills";


const theme = createMuiTheme({
  palette:{
    primary:{main:"#1eba8b"},
    secondary:{main:"#87e8c8"},
  
   }
})

function App() {
  const classes = useStyles();
  return (
    <MuiThemeProvider theme={theme}>
      <div className={classes.root}>
      <NavBar />
      <About title="About Me" id="about" dark={true} />
      <Skills title="My Skills" id="skills" dark={false}/>
      <MyWork title="My Projects" id="work" dark={true}/>
      <Contact title="Get in touch" id="contact" dark={false}/>
    </div>
    </MuiThemeProvider>
  );
}

const useStyles = makeStyles((theme) => ({ 
  root: {
    background:"#d4d5d6",
    width:"device-width"
  }
}))

export default App;
